var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9803 12.0673L15.2298 15.2197C15.1359 15.6879 14.7607 16 14.2916 16C6.41089 15.9688 0 9.57041 0 1.70508C0 1.23691 0.281454 0.86237 0.750543 0.768735L3.90908 0.0196561C4.34689 -0.0739787 4.81598 0.175714 5.00362 0.581465L6.47343 3.98353C6.62979 4.38928 6.53598 4.85746 6.19198 5.10715L4.50326 6.48046C5.56652 8.63406 7.31779 10.3819 9.50687 11.4431L10.8829 9.75768C11.133 9.44556 11.6021 9.32071 12.0087 9.47677L15.4174 10.9437C15.8239 11.1622 16.0741 11.6304 15.9803 12.0673Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.e41f28abdbc2d74a8f481c8d4fd8ec2c.svg";
export { ForwardRef as ReactComponent };